import httpUtils from '../../utils/HttpUtils'
import session from '../../utils/Session'

class TradeOfflineService {

  //查询线下订单列表
  async list(status='',pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/list', {status,pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //查询线下订单详情
  async detail(id) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/detail', {id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //取消线下订单
  async cancelOffline(id) {
    console.log('取消订单');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/cancel', {id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //退订单订金
  async refundOffline(id,reason) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/refund', {id,reason})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //支付线下订单
  // browserType 浏览器类型 1、微信浏览器 2、非微信浏览器
  async payOffline(id = '',browserType = '2') {
    console.log('支付订单');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/pay', {id,browserType})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //生成线下订单 depositId:订金订单编号
  async createOrder(shopId = '',depositId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/create/amount')
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存线下订单并支付
  // browserType 浏览器类型 1、微信浏览器 2、非微信浏览器
  async saveAndPayOrder(tradeOfflineFormData = {}) {
    console.log('保存订单并支付');
    let result = null;
    try {
      result = await httpUtils.post('/mall/trade/offline/saveandpay', tradeOfflineFormData)
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存线下支付凭证
  async paiedTailMoney(tradeOfflineFormData = {}) {
    let result = null;
    try {
      console.info(tradeOfflineFormData)
      result = await httpUtils.post('/mall/trade/offline/paied/tail/money', tradeOfflineFormData)
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new TradeOfflineService()
